/**
 * Created by vladislav on 05.03.2020
 */

const CurrentLetterView = cc.Node.extend({
    ctor: function (char) {
        this._super();
        this.char = char;
        this.wasFlying = false;
        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.CurrentLetterView;

        this.charView = CharView.Create(char, {
            noBg: styles.noBg,
            font: cleverapps.styles.FONTS.BOARD_TEXT
        });
        this.addChild(this.charView);
        this.setContentSize2(this.charView.getContentSize());
        this.charView.setAlignment(this.width / 2, this.height / 2);

        this.setScale(styles.scale);
        this.baseScale = this.scale;

        this.setCascadeColorEnabled(true);
        this.setCascadeOpacityEnabled(true);
    },

    isFlying: function () {
        return this.wasFlying;
    },

    setFlying: function (flying) {
        this.wasFlying = flying;
    },

    showUp: function () {
        this.setOpacity(0);
        this.setScale(0.6 * this.baseScale);
        this.runAction(new cc.Spawn(
            new cc.FadeIn(0.2).easing(cc.easeIn(3)),
            new cc.ScaleTo(0.2, this.baseScale).easing(cc.easeIn(3))
        ));
    }
});

cleverapps.styles.CurrentLetterView = {
    scale: 1.0
};